import { resolveModuleHeroIcon } from './moduleHeroIcons'
import { resolveModuleLucideIcon } from './moduleLucideIcons'
import type { ModuleIconComponent } from './moduleIconTypes'

/** Resolve ícone Heroicons ou Lucide pelo nome salvo no banco. */
export const resolveModuleIcon = (name?: string): ModuleIconComponent | undefined => {
  if (!name) return undefined
  const key = name.toLowerCase()
  return resolveModuleHeroIcon(key) ?? resolveModuleLucideIcon(key)
}
